import React from 'react';
import { Lock, CreditCard, ShieldCheck } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 border-t border-zinc-900 py-12 pb-24 md:pb-12" data-id="element-128">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-129">
        <div className="grid md:grid-cols-3 gap-8 items-center md:items-start" data-id="element-130">
          {/* Brand */}
          <div className="text-center md:text-left" data-id="element-131">
            <span className="text-white font-bold text-xl tracking-tight block mb-2" data-id="element-132">
              Sistema iPhone Ads
            </span>
            <p className="text-zinc-500 text-sm" data-id="element-133">
              Guía práctica de publicidad para tiendas de iPhone.
            </p>
          </div>

          {/* Links Placeholder */}
          <div className="flex flex-col items-center md:items-start gap-3 text-sm text-zinc-400" data-id="element-134">
            <a href="#" className="hover:text-white transition-colors" data-id="element-135">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-136">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-137">
              Política de Reembolsos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-138">
              Contacto
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-139">
            <div className="flex gap-4 text-zinc-500" data-id="element-140">
              <Lock className="w-6 h-6" data-id="element-141" />
              <CreditCard className="w-6 h-6" data-id="element-142" />
              <ShieldCheck className="w-6 h-6" data-id="element-143" />
            </div>
            <p className="text-xs text-zinc-600" data-id="element-144">
              Pagos procesados de forma segura.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-900 text-center text-xs text-zinc-600" data-id="element-145">
          &copy; {new Date().getFullYear()} Sistema iPhone Ads. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}